module.exports = __webpack_public_path__ + "static/media/ios-checkbox-outline.dc2e64ee.svg";